import { Col, Row, Card, message, Spin, Button, Space, Empty } from "antd";
import React, { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_LOAD_BY_DATE,
} from "../../API/apiUrls";
import ReactECharts from "echarts-for-react";
import { SearchOutlined, RollbackOutlined } from "@ant-design/icons";

//use redux
import axios from "axios";
import dayjs from "dayjs";
import { ThaiMonthPicker } from "../../../hook/ThaiMonthPicker";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { useNavigate } from "react-router-dom";

const Main = ({ onClick }) => {
  const [loading, setLoading] = useState(false);
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [dataPickerLoad, setDatePickerLoad] = useState();
  const [arrData, setArrData] = useState([]);
  const navigate = useNavigate();

  const handlePreLoad = () => {
    let preDataLoad = {};

    let apiUse = POST_LOAD_BY_DATE;
    preDataLoad = {
      selectType: 0,
      date: dayjs(dataPickerLoad).format("YYYY-MM-DD"),
    };
    setArrData([]);
    loadData(preDataLoad, apiUse);
  };

  const loadData = async (payload, apiUse) => {
    setLoading(true);
    try {
      const { data, status } = await axios.post(
        BASE_URL_BEN + apiUse,
        payload,
        { headers: HEADERS_EXPORT_BEN }
      );

      if (
        status !== 200 ||
        !data ||
        (Array.isArray(data) && data.length === 0)
      ) {
        message.warning("ไม่มีข้อมูล");
        return;
      }

      console.log("res data", data);
      filterData(data);
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("API error:", status, serverMsg || error.message);

      message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (value) => {
    if (Array.isArray(value)) {
      let filteredDataCompany;
      console.log(userCompany);

      if (userCompany === "3") {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return true;
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.contractNo.includes("UD")
          );
        });
      } else {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false;
          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      let i = 1;

      const newData = filteredDataCompany.map((item) => ({
        ...item,
        key: i++,
      }));

      setArrData(newData);
      setLoading(false);
    }
  };

  const splitByStatus = (rows = []) => {
    const buckets = { pending: [], reply: [], web: [], returned: [] };

    (rows || []).forEach((it) => {
      const statusData = it?.status;
      if (statusData === 1) buckets.reply.push(it);
      else if (statusData === 2) buckets.web.push(it);
      else if (statusData === 3) buckets.returned.push(it);
      else buckets.pending.push(it); // รวม 0/null
    });
    const counts = {
      total: rows.length,
      pending: buckets.pending.length,
      reply: buckets.reply.length,
      web: buckets.web.length,
      returned: buckets.returned.length,
    };

    return { buckets, counts };
  };

  const pieChart = (rows = []) => {
    const { counts } = splitByStatus(Array.isArray(rows) ? rows : []);
    const total =
      (counts?.web || 0) +
      (counts?.reply || 0) +
      (counts?.returned || 0) +
      (counts?.pending || 0);

    if (!rows.length || total === 0) {
      return (
        <div
          style={{
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="ไม่มีข้อมูล" />
        </div>
      );
    }

    const option = {
      title: {
        text: "กราฟแสดงการตอบกลับรายเดือน",
        subtext: `จำนวน ${rows.length}`,
        left: "right",
      },
      tooltip: { trigger: "item" },
      legend: { orient: "vertical", left: "left" },
      series: [
        {
          name: "สถานะการตอบกลับ",
          type: "pie",
          radius: "70%",
          label: { formatter: "{b}: {c} ({d}%)" },
          data: [
            { value: counts.web, name: "เว็บไปรษณีย์" }, // 2
            { value: counts.reply, name: "ใบตอบกลับ" }, // 1
            { value: counts.returned, name: "ตีกลับ" }, // 3
            { value: counts.pending, name: "ยังไม่ตอบกลับ" }, // 0/null
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0,0,0,0.5)",
            },
          },
        },
      ],
      color: ["#FFD700", "#33FF57", "#FFA500", "#FF4D4F"],
    };

    return (
      <ReactECharts option={option} style={{ height: 400, width: "100%" }} />
    );
  };

  return (
    <>
      <Card>
        <Row>
          <Col span={"24"} style={{ textAlign: "start" }}>
            <Space direction="horizontal" size={8}>
              <ThaiMonthPicker
                value={dataPickerLoad}
                onChange={setDatePickerLoad}
                size="large"
              />

              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                  marginLeft: 5,
                }}
                onClick={handlePreLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          {pieChart(arrData)}
        </Spin>
      </Card>
    </>
  );
};

const ReportResponse = MotionHoc(Main);
export default ReportResponse;
